import * as ActionTypes from '../../constants/common/PopupActionTypes';

const initialState = {
    // 코멘트
    // - 답글 달기
    isCommentReplyPopupOpened: false,
    commentReplyPopupCommentIds: 0,
    // - 스팸 차단
    isCommentBlockPopupOpened: false,
    commentBlockPopupCommentIds: 0,

    // 사이드바
    // - 사이드바 편집
    isEditSidebarModuleOpened:false,
    sidebarModule: null,

    // 스킨
    // - 스킨 상세
    isSkinDetailPopupOpened:false,
    // - 에러
    isErrorToastPopupOpened:false,
    // - 로딩 팝업
    isLoadingPopupOpened:false,
    // - 스킨 저장
    isSkinSavePopupOpened: false,


    // 카테고리
    // - 카테고리 이동 팝업
    isMovingCategoryOpened : false,
    category: null,

    clearDataResultPopupOpened:false,
    clearDataResultCode : null,
    clearDataResultMessage : null,
    closeBlogResultPopupOpened:false,
    clearBlogResultCode : null,
    clearBlogResultMessage : null,
};

export default (state = initialState, action) => {
    switch (action.type) {
        case ActionTypes.SHOW_COMMENT_REPLY_POPUP:
            return Object.assign({}, state, {
                isCommentReplyPopupOpened: true,
                commentReplyPopupCommentIds: action.commentId
            });
        case ActionTypes.SHOW_COMMENT_BLOCK_POPUP:
            return Object.assign({}, state, {
                isCommentBlockPopupOpened: true,
                commentBlockPopupCommentIds: action.commentId
            });
        case ActionTypes.SHOW_CLEAR_DATA_RESULT_POPUP:
            return Object.assign({}, state, {
                clearDataResultPopupOpened: true,
                clearDataResultCode : action.resultCode,
                clearDataResultMessage : action.resultMessage,
            });
        case ActionTypes.SHOW_CLOSE_BLOG_RESULT_POPUP:
            return Object.assign({}, state, {
                closeBlogResultPopupOpened: true,
                clearBlogResultCode : action.resultCode,
                clearBlogResultMessage : action.resultMessage,
            });
        case ActionTypes.CLOSE_POPUP:
            return Object.assign({}, state, {
                isCommentReplyPopupOpened: false,
                isCommentBlockPopupOpened: false,
                isSkinSavePopupOpened: false,
                isSkinDetailPopupOpened: false,
                isEditSidebarModuleOpened: false,
                isErrorToastPopupOpened : false,
                isMovingCategoryOpened:false,
                clearDataResultPopupOpened : false,
                closeBlogResultPopupOpened : false,
                sidebarModule:null,
                category:null,
            });
        case ActionTypes.SHOW_SKIN_ADD_POPUP:
            return Object.assign({}, state, {
                isSkinSavePopupOpened: true,
                title: action.title,
                description: action.description,
                callBack: action.callBack
            });
        case ActionTypes.SHOW_SKIN_DETAIL_POPUP:
            return Object.assign({}, state, {
                isSkinDetailPopupOpened: true,
                skin: action.skin,
            });
        case ActionTypes.SHOW_EDIT_SIDEBAR_MODULE_POPUP :
            return Object.assign({}, state, {
                isEditSidebarModuleOpened : true,
                sidebarModule : action.module
            })
        case ActionTypes.SHOW_ERROR_TOAST_POPUP :
            return Object.assign({}, state, {
                isErrorToastPopupOpened : true,
                title: action.title,
                description: action.description,
            })
        case ActionTypes.SHOW_LOADING_POPUP :
            return Object.assign({}, state, {
                isLoadingPopupOpened : true,
                loadingPopupMessage : action.loadingPopupMessage
            })
        case ActionTypes.HIDE_LOADING_POPUP :
            return Object.assign({}, state, {
                isLoadingPopupOpened : false,
            })
        case ActionTypes.SHOW_MOVING_CATEGORY_POPUP :

            return Object.assign({}, state, {
                isMovingCategoryOpened : true,
                category : action.category
            })

    }
    return state
}
